module.exports = __webpack_public_path__ + "img/logo-muzikairconcert.f9944b62.svg";